import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const data = [
  { name: "Lagos", value: 160 },
  { name: "Ogun", value: 50 },
  { name: "Oyo", value: 25 },
  { name: "Osun", value: 15 },
  { name: "Others", value: 12 },
];

const COLORS = ["#1970E6", "#6226EF", "#E41B1B", "#3CC3DF", "#FFAE4C"];

const OrderStatusPerLocation = () => {
  return (
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            innerRadius={40}
            fill="#8884d8"
            label={({ name }) => `${name}`} // only show value on the slice
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => `${value}`}
            labelFormatter={(label) => `${label}`}
          />
          {/* Removed the <Legend /> */}
        </PieChart>
      </ResponsiveContainer>
  );
};

export default OrderStatusPerLocation;
